/**
 * Il posto della BARRA DELLA SCHEDA: un contenitore vuoto che `AppShell` monta NEL FLUSSO, subito
 * sopra `<MainCta />` e fuori dallo scorrevole. Una schermata che ha un tasto d'azione suo — oggi il
 * bottone unico dell'incontro Limulo (L-2196) — ci rende dentro con un portale.
 *
 * 🔴 Perche' non una barra `fixed`: la prima stesura lo era, e copriva `ActiveMatchPill` (che sta nel
 * flusso sotto `MainCta`) e costringeva la pagina a un `pb-40` scritto a mano, un'altezza tirata a
 * indovinare (revisione di tma-orc su #384, punti 4 e 8). Nel flusso lo scorrevole si accorcia da
 * solo di quanto serve, e la pastiglia resta visibile sotto.
 */
export const BARRA_SCHEDA_ID = 'tma-barra-scheda';
